import {Helmet} from "react-helmet";
import {Home_blog_2026, Home_ideas_2026, Header_2026, Footer_2026, Home_libros_2026, Home_contacto_2026 } from '../container';
import '../App.css';
import { useTranslation } from 'react-i18next';
import LazyLoad from 'react-lazyload';

function Home() {
  const [t, i18n] = useTranslation("home");
  const liga_lang3='/'+i18n.language+"/LibroNegocios";

  return (
    <div className="App">
      <Header_2026/>
      <Home_blog_2026/>
      <Home_ideas_2026/>
      <Home_libros_2026/>
      <Home_contacto_2026/>
      <Footer_2026/>

    </div>
    
  );
}

export default Home;